import {
  Box,
  Button,
  Container,
  createStyles,
  Text,
  Accordion,
  Table,
  Menu,
  ActionIcon,
  ScrollArea,
  Center,
  Checkbox,
  Paper,
  Tooltip,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import "./style.css";
import AddProvider from "../../../components/ClaimBilling/AddProvider";
import AddClient from "../../../components/ClaimBilling/AddClient";
import AddPayer from "../../../components/ClaimBilling/AddPayer";
import { getProccode, getServicecode } from "../../../services/servicecode";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import {
  createpayer,
  getpayer,
  getpayerlist,
  removepayer,
} from "../../../services/payer";
import { useSelector } from "react-redux";
import EditPayer from "../../../components/ClaimBilling/EditPayer";
import EditProvider from "../../../components/ClaimBilling/EditProvider";
import {
  AddBillingCache,
  createBilling,
  getAllBillingModal,
  getAllBillingPayments,
  getAllFacilitiesModal,
  getBillingCard,
} from "../../../services";
import { decrypt, encrypt } from "../../../utils";
import {
  getBillingProvider,
  removeProvider,
} from "../../../services/billingprovider";
import TableLoader from "../../../components/TableLoader";

import RecordNotFound from "../../../components/RecordNotFound";
import { IconEye, IconTrash } from "@tabler/icons-react";
import { IconEdit,IconClipboardCheck } from "@tabler/icons-react";
import { BiDotsVerticalRounded } from "react-icons/bi";
import EditClient from "../../../components/ClaimBilling/EditClient";
import SettingDrawer from "../../../components/BillingInvoices/InvoiceSetting/SettingDrawer";
import AddBillingDate from "../../../components/ClaimBilling/AddBillingDate";
import ViewClientClaimServices from "../../../components/ClaimBilling/ViewClientClaimServices";
import BillingSearchBar from "../../../components/Document/BillingSearchBar";
import BillingAgree from "../../../components/ClaimBilling/BillingAgree";
import BillingSearchAll from "../../../components/Document/BilllingSearchAll";
import CustomBillingPagination from "../../../components/Pagination/CustomBillingPagination";
import { ImCross } from "react-icons/im";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { getAllPatients } from "../../../services/patient";
import { PaymentTab } from "./PaymentTab";
import ProviderEnrollment from "../../../components/ClaimBilling/ProviderEnrollment";

const useStyles = createStyles(() => ({
  drawer: {
    ".mantine-Drawer-content": {
      backgroundColor: "#f5f5f5",
    },
  },

  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },

  tableRoot: {
    "tbody tr:hover td": {
      backgroundColor: "#FFF6ED !important",
    },
  },

  selected: {
    "& td": {
      background: "#FFF6ED",
    },
  },

  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    justifyContent: "center",
  },

  mainContainer: {
    background: "#f5f5f5",
    display: "flex",
    borderRadius: "16px",
    border: "1px solid #E5E5E5",
    backgroundColor: "#FFF",
    width: "100%",
    margin: "auto",
    // padding: "12px 8px",
    marginTop: "20px",
    "@media (max-width:800px)": {
      width: "90%",
    },
    "@media (max-width:500px)": {
      width: "100%",
    },
    // justify-content: center'
    // align-items: center;

    // margin-top: 20px;
  },

  searchbox: {
    // marginTop: "50px",
    // marginBottom: "50px",
    background: "#FFF",
    padding: "8px 26px",
    width: "100% !important",
    marginBottom: "10px",
    // marginTop: "50px",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  tabs: {
    width: "100%",
    marginTop: "40px",
    marginBottom: "140px",
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "12px",
    padding: "27px 16px",
    background: "#FFF",

    "@media (max-width:1200px)": {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
  },

  displaybox: {
    display: "flex",
    gap: "20px",
    "@media (max-width:1200px)": {
      display: "flex",
      flexDirection: "column",
    },
  },

  reviewpad: {
    padding: "16px 31px",
  },

  tabbtn: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
  },

  claimtype: {
    color: "#FFAF4A",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
  },

  tabsinner: {
    // width: "15%",
    borderRadius: "8px",
    border: "1px solid  #D0D5DD",
    background: " #F9FAFB",
    padding: "12px 20px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    textAlign: "center",
  },

  button: {
    "&:hover": {
      background: "#FFAF4A",
      color: "#FFFFFF",
      opacity: 0.8,
    },
  },

  mainbillingbox: {
    width: "100%",
    // margin: auto;
    // display: flex;
    // flex-direction: column;

    // align-items: center;
  },

  mainbillingcontainer: {
    background: "#F5F5F5",
    // display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "fit-content",
    padding: "14px 28px 14px 20px",

    "@media (max-width:900px)": {
      paddingRight: "10px",
      paddingLeft: "10px",
    },
  },

  clientInfoCardDataParent: {
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    "@media (max-width:1300px)": {
      gap: "10px",
    },
  },

  container: {
    // margin: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: ".5rem",
    padding: "12px 8px",
  },
  userDetails: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    borderStyle: "solid",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  details: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  noteDetails: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  noteContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: ".5rem",
  },
  item: {
    // border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "8px",
    overflow: "hidden",
    background: "#fff",
  },
  outcomeBox: {
    display: "flex",
    gap: "1rem",
    backgroundColor: "#FAFAFA",
    padding: "1rem",
    borderRadius: "10px",
    border: "1px solid #E7EBEF",
    marginBottom: "1rem",
    marginTop: "1rem",
  },
  coutcomeItem: {
    display: "flex",
    gap: ".4rem",
    flex: "1",
    flexDirection: "column",
  },
  outcomeNote: {
    backgroundColor: "#FAFAFA",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5E5",
    borderWidth: "2px",
    borderStyle: "solid",
    marginTop: "1rem",
  },

  // img:{
  //   position: "relative",
  //   top:"10px",
  // },
  btns: {
    display: "flex",
    gap: "1rem",
    // justifyContent: "space-between",
    justifyContent: "flex-end",
    gap: "4px",
    marginTop: "12rem",
  },

  backbtn: {
    borderRadius: "8px",
    border: "1px solid #F5F5F5",
    background: "#F5F5F5",

    /* Shadow/xs */
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  },

  mainbox: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "50%",
    margin: "auto",
    "@media (max-width:1100px)": {
      width: "85%",
    },
  },

  text: {
    marginTop: "5px",
    marginLeft: "-21px",
    "@media (max-width:500px)": {
      fontSize: "14px",
    },
  },

  beginbilling: {
    textAlign: "center",
    alignItems: "center",
    marginTop: "39px",
    // marginBottom: "22px",
    cursor: "pointer",
  },

  suggestionbox: {
    marginBottom: "15px",
  },

  suggestionminibox: {
    display: "flex",
    gap: "10px",
    height: "52px",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "8px",
    border: "1px solid #E4E4E7",
    background: "#FFF",
  },

  mt: {
    marginTop: "20px",
  },

  accordionbox: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  box: {
    width: "30px",
    height: "30px",
    border: "1px solid #000",
    background: "#D9D9D9",
    color: "#FFF",
  },

  cp: {
    cursor: "pointer",
  },

  btnflex: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },

  addbtn: {
    marginTop: "44px",
    marginBottom: "4px",
    display: "flex",
    justifyContent: "flex-end",
  },
  stepNumberText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  checkbox: {
    width: "20px",
    height: "20px",
    // borderRadius: "6px",
    // border: "1px solid  #D0D5DD",
    // background: "#FFF",
    marginRight: "10px",
  },

  // selectbox: {
  //   //  width: "100%",
  //   // padding: "37px 365px 0px 365px",
  //   // display: "flex",
  //   // alignItems: "center",
  //   // justifyContent: "center",
  //   // gap: "150px",
  //   // borderRadius: "12px",
  //    background: "#FFF",
  //   // height: "73px",
  //   "@media (max-width:1400px)": {
  //     display: "flex",
  //     flexDirection: "column",
  //     gap: "5px",
  //     // padding: "20px",
  //     height: "fit-content",
  //     // width:'50%'
  //     // height:'fitcontent'
  //   },

  //   "@media (max-width:1100px)": {
  //     display: "flex",
  //     flexDirection: "column",
  //     gap: "5px",
  //     // padding: "20px",
  //     height: "fit-content",
  //     // width:'50%'
  //     // height:'fitcontent'
  //   },
  // },

  // insidebox: {
  //   //  width: "35%",
  //   display: "flex",
  //   justifyContent: "space-between",
  //   // gap: "43px",
  //   // marginTop: "37px",
  //   width:'93%'
  // },

  // iconbox: {
  //   // width: "12%",
  //   display: "flex",
  //   gap: "10px",
  // },

  selectbox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // borderRadius: "12px",
    background: "#FFF",
    // padding: "10px 20px",
    overflow: "hidden",
  },

  insidebox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    width: "100%",
    margin: "auto",
  },

  iconbox: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    zIndex: 1,
    width: "100%",
  },

  newbeginbilling: {
    padding: "12px 28px",
    fontSize: "20px !important",
    fontWeight: "400 !important",
    backgroundColor: "#FFF",
    color: "#000",
    position: "relative",
    width: "100%",
    cursor: "pointer",
    textAlign: "center",
    clipPath: "polygon(0 0, 89% 0, 94% 50%, 88% 100%, 0 100%)",
    // transition: "background 0.3s",
  },

  newborder: {
    backgroundColor: "#FFAF4A",
    color: "#000",
    fontWeight: "500 !important",
  },

  border: {
    width: "104px",
    //  padding: "8px 16px",
    // height: "36px",
    borderRadius: "4px 4px 0px 0px",
    borderBottom: "3px solid #171717",
  },

  back: {
    marginTop: "21px",
    marginBottom: "27px",
    display: "flex",
    gap: "1px",
    cursor: "pointer",
  },
  header: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "700",
    color: "#000",
  },

  row: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "400",
    color: "#000",

    // "&:hover": {
    //   background: "#FFD580",
    //   opacity: 0.8,
    // },
  },

  // review box css starts here
  claimreviewbox: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "40px",
  },

  viewheaders: {
    color: "#737373 !important",
    fontSize: "12px !important",
    fontWeight: "400 !important",
    fontFamily: "Inter !important",
  },

  viewpara: {
    color: "#262626 !important",
    fontSize: "20px !important",
    fontWeight: "500 !important",
    fontFamily: "Inter !important",
  },

  alertbox: {
    marginTop: "40px",
    marginBottom: "40px",
    display: "flex",
    gap: "8px",
    padding: "4px 10px 4px 4px",
    width: "100%",
    borderRadius: "16px",
    background: "#FEF3F2",
    mixBlendMode: "multiply",
  },

  noticebox: {
    marginTop: "40px",
    marginBottom: "40px",
    display: "flex",
    gap: "8px",
    padding: "4px 10px 4px 4px",
    width: "100%",
    borderRadius: "16px",
    background: "#FFFAEB",
    mixBlendMode: "multiply",
  },
}));

const BillingClaimForm = () => {
  const { classes } = useStyles();

  const [settingdrawerOpened, setSettingDrawerOpened] = useState(false);
  const closeSettingDrawer = () => setSettingDrawerOpened(false);
  const { billingnotes } = useSelector((state) => state?.note);
  const location = useLocation();
  const billingItem = location.state?.billingItem;

  console.log("Received billingItem:", billingItem);

  const alllistpayer = useSelector(
    (state) => state?.payer?.alllistpayer?.payerlist
  );

  const [state, setState] = useState({
    provider: false,
    client: false,
    payer: false,
    addProvider: false,
    addClient: false,
    addPayer: false,
    reviewclaim: false,
    payment: false,
  });

  const { profile } = useSelector((state) => state?.profile);
  const [agree, setAgree] = useState(false);
  const [EditPayerModalOpen, setEditPayerModalOpen] = useState(false);
  const [providerEnrollment, setProviderEnrollment] = useState(false);
  // const [selectedProviders, setSelectedProviders] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState(() => {
    const saved = billingItem?.provider;

    try {
      return saved ? [saved] : [];
    } catch (err) {
      console.error("Failed to parse selectedprovider from localStorage", err);
      return [];
    }
  });

  //  const [payerclient, setPayerclient] = useState([]);

  const [payerclient, setPayerclient] = useState(() => {
    const saved = billingItem?.payer;

    try {
      return saved ? [saved] : [];
    } catch (err) {
      console.error("Failed to parse selectedprovider from localStorage", err);
      return [];
    }
  });

  const [billingclient, setBillingclient] = useState([]);
  const [payer, setPayer] = useState(null);
  const [editprovider, setEditProvider] = useState(false);
  const [editclient, setEditClient] = useState(false);
  const [client, setClient] = useState(false);
  const [provideritem, setProvideritem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [view, setView] = useState(false);
  const [manageall, setManageAll] = useState(false);

  const { manage, claimData } = location?.state || {};
  const [billingdate, setBillilingDate] = useState(null);
  //  const [billingdate, setBillilingDate] = useState(billingItem?.billingServicesDates|| null);
  const [billingdatemodal, setBillilingDateModal] = useState(false);
  const [showservice, setShowservices] = useState(false);
  const [existingServices, setExistingServices] = useState(false);
  const [payerValue, setPayerValue] = useState("");
  const [selectedPayer, setSelectedPayer] = useState(null);
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [finalservices, SetFinalServcices] = useState([]);
  // const [finalservices, SetFinalServcices] = useState(() => {
  //   const saved = billingItem?.billingServices;

  //   try {
  //     return saved ? saved : [];
  //   } catch (err) {
  //     console.error("Failed to parse billingServices from api", err);
  //     return [];
  //   }
  // });

  const [firstEffectDone, setFirstEffectDone] = useState(false);
  const [editservices, setEditServices] = useState(false);
  const [billingloading, setBillingLoading] = useState(false);
  const [draftbillingloading, setDraftBillingLoading] = useState(false);

  const [achservices, setAchServices] = useState({
    accountNumber: "",
    routingNumber: "",
    bankName: "",
    accountholdername: "",
  });

  //  console.log('manage',manage);

  // console.log('state',state);

  const backfunction = () => {
    if (!manage) {
      if (state.reviewclaim) {
        setState({ ...state, client: true, reviewclaim: false });
      } else if (state.payment) {
        setState({ ...state, client: true, payment: false });
      } else if (state.payer) {
        setState({ ...state, provider: true, payer: false });
      } else if (state.client) {
        setState({ ...state, payer: true, client: false });
      } else {
        navigate("/home/billing");
      }
    } else {
      navigate("/home/billing");
    }
  };

  const [searchloading, setSearchLoading] = useState(false);
  const [paymentype, setPaymentType] = useState("");

  // const [loading,setLoading]=useState(false)

  const clearsearch = async () => {
    setSelectedPayer(null);
    setPayerValue("");
    let payload = {
      page: 1,
    };
    await getpayer(payload);
  };

  const { patients } = useSelector((state) => state.patient);

  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // console.log('patients here',patients);
  // console.log('patients here 2',patients.patients);

  const { allbillingclient } = useSelector((state) => state?.billingclient);

  const [providerSearch, setProviderSearch] = useState("");
  const [payerSearch, setPayerSearch] = useState("");

  const { loading, allbillingprovider } = useSelector(
    (state) => state.billingprovider
  );

  // console.log('selectedPayer',selectedPayer);

  // console.log('payerclient',payerclient);

  // console.log("state", state);

  // console.log("manageall", manageall);
  //  console.log("billingclient", billingclient);

  useEffect(() => {
    const localbillingdata = billingItem?.billingServicesDates;
    const localfinalservices = billingItem?.billingServices;
    if (localbillingdata) {
      setBillilingDate(localbillingdata);
    }

    if (localfinalservices) {
      SetFinalServcices(localfinalservices);
    }
  }, []);

  // console.log("manage", manage);

  // useEffect(() => {
  //   if (manage !== undefined) {
  //     setState((prevState) => {
  //       const resetState = {
  //         provider: false,
  //         client: false,
  //         payer: false,
  //         addProvider: false,
  //         addClient: false,
  //         addPayer: false,
  //         reviewclaim: false,
  //         payment: false,
  //       };

  //       return {
  //         ...resetState,
  //         [manage]: true,
  //       };
  //     });

  //     setManageAll(true);
  //     setFirstEffectDone(true);
  //   } else {
  //     if (profile?.user.billingAgree || allbillingprovider.count > 0) {
  //       const lastStep = localStorage.getItem("laststep");

  //       // setState({ ...state, provider: true });
  //       const updatedState = { ...state, provider: true };

  //       if (lastStep === "provider") {
  //         updatedState.provider = true;
  //         updatedState.payer = false;
  //         updatedState.client = false;
  //       } else if (lastStep === "client") {
  //         updatedState.provider = false;
  //         updatedState.payer = false;
  //         updatedState.client = true;
  //       } else if (lastStep === "payer") {
  //         updatedState.provider = false;
  //         updatedState.payer = true;
  //         updatedState.client = false;
  //       } else if (lastStep === "reviewclaim") {
  //         updatedState.reviewclaim = true;
  //         updatedState.provider = false;
  //         updatedState.payer = false;
  //         updatedState.client = false;
  //       }

  //       setState(updatedState);
  //     }
  //   }
  // }, [manage]);


    useEffect(() => {
    if (manage !== undefined) {
      setState((prevState) => {
        const resetState = {
          provider: false,
          client: false,
          payer: false,
          addProvider: false,
          addClient: false,
          addPayer: false,
          reviewclaim: false,
          payment: false,
        };

        return {
          ...resetState,
          [manage]: true,
        };
      });

      setManageAll(true);
      setFirstEffectDone(true);
    } else {
      if (profile?.user.billingAgree || allbillingprovider.count > 0) {
        const lastStep = billingItem?.nextstep || "provider";

        // setState({ ...state, provider: true });
        const updatedState = { ...state, provider: true };

        if (lastStep === "provider") {
          updatedState.provider = true;
          updatedState.payer = false;
          updatedState.client = false;
        } else if (lastStep === "client") {
          updatedState.provider = false;
          updatedState.payer = false;
          updatedState.client = true;
        } else if (lastStep === "payer") {
          updatedState.provider = false;
          updatedState.payer = true;
          updatedState.client = false;
        } else if (lastStep === "review") {
          updatedState.reviewclaim = true;
          updatedState.provider = false;
          updatedState.payer = false;
          updatedState.client = false;
        }

        setState(updatedState);
      }
    }
  }, [manage]);

  // useEffect(() => {
  //   if (profile?.user.billingAgree || allbillingprovider.count > 0) {
  //     setState({ ...state, provider: true });
  //   }
  // }, [profile?.user.billingAgree]);

  // console.log("payerclient", payerclient);

  // console.log("billingcliet", billingclient);

  useEffect(() => {
    const payload = { page: currentPage };
    // Always run these two APIs
    getServicecode();
    getProccode();
    getAllFacilitiesModal();
    // Conditional API calls based on state
    if (state.provider) {
      getBillingProvider(payload);
    }
    if (state.client) {
      if (manage) {
        getAllPatients(currentPage, true, true);
      } else {
        getAllPatients("all", true, true);
      }

      getBillingProvider({ page: 1 });
      getpayer({ page: 1 });
    }
    if (state.payer) {
      getpayer(payload);
    }
    if (state.payment) {
      getAllBillingPayments(payload);
      getBillingCard();
    }
  }, [currentPage, state]);

  useEffect(() => {
    console.log("here 1st");
    if (patients?.count === patients?.patients?.length) {
      if (payerclient?.length > 0) {
        // console.log('here 2nd');
        // console.log('payerclient check', payerclient);
        // console.log('patients.allPatients check', patients.allPatients);

        payerclient?.forEach((payer) => {
          let matchingPatients = null;

          const storedClients = billingItem?.client || [];
          // console.log("storedClients", storedClients);

          if (storedClients.length > 0) {
            matchingPatients = storedClients
              .map((entry) => {
                const decryptedname = decrypt(entry?.name);
                const decryptedForm1 = decrypt(entry?.form1);
                const decryptedForm2 = decrypt(entry?.form2);
                const decryptedForm3 = decrypt(entry?.form3);

                const billingInsurance = decryptedForm2?.BillingInsurance?.[0];
                const providerId = entry?.providerId?.[0];

                const isPayerMatch =
                  billingInsurance?.payer?.value === payer?.id;
                const isProviderMatch =
                  providerId === selectedProviders?.[0]?.id;
                const hasValidAuthDate =
                  billingInsurance?.authorizationEndDate &&
                  !moment
                    .tz(billingInsurance.authorizationEndDate, userTimezone)
                    .isBefore(moment.tz(new Date(), userTimezone), "day");

                if (isPayerMatch && isProviderMatch && hasValidAuthDate) {
                  return {
                    ...entry,
                    name: decryptedname,
                    form1: decryptedForm1,
                    form2: decryptedForm2,
                    form3: decryptedForm3,
                  };
                }

                return null;
              })
              .filter(Boolean);
          } else {
            console.log("in the else");

            matchingPatients = patients?.patients?.filter(
              (patient) =>
                patient.form2?.BillingInsurance?.[0]?.payer.value ===
                  payer?.id &&
                patient?.providerId?.[0].id === selectedProviders[0]?.id &&
                patient?.form2?.BillingInsurance?.[0]?.authorizationEndDate &&
                !moment
                  .tz(
                    patient.form2?.BillingInsurance?.[0]?.authorizationEndDate,
                    userTimezone
                  )
                  .isBefore(moment.tz(new Date(), userTimezone), "day")
            );
          }

          console.log("matchingPatients", matchingPatients);

          if (matchingPatients?.length === 0) return;

          matchingPatients?.forEach((selectedClient) => {
            if (
              !billingclient?.some(
                (client) =>
                  client?.payer === payer.id &&
                  client?.selectedClient.id === selectedClient.id &&
                  selectedClient?.form2?.BillingInsurance?.[0]
                    ?.authorizationEndDate &&
                  !moment
                    .tz(
                      selectedClient.form2?.BillingInsurance?.[0]
                        ?.authorizationEndDate,
                      userTimezone
                    )
                    .isBefore(moment.tz(new Date(), userTimezone), "day")
              )
            ) {
              setBillingclient((prevState) => [
                ...prevState,
                {
                  selectedClient,
                  payer: payer.id,
                },
              ]);
            }
          });
        });
      }
    }
  }, [
    payerclient.length,
    selectedProviders.length,
    patients?.patients?.length,
  ]);

//  useEffect(() => {
//     console.log("here 1st");
//     if (patients?.count === patients?.patients?.length){

//     if (payerclient?.length > 0) {
//       // console.log('here 2nd');
//       // console.log('payerclient check', payerclient);
//       // console.log('patients.allPatients check', patients.allPatients);

//           const storedClients = billingItem?.client || [];
//           // console.log("storedClients", storedClients);

//           if (storedClients.length > 0) {
//             matchingPatients = storedClients
//               .map((entry) => {
//                 const decryptedname = decrypt(entry?.name);
//                 const decryptedForm1 = decrypt(entry?.form1);
//                 const decryptedForm2 = decrypt(entry?.form2);
//                 const decryptedForm3 = decrypt(entry?.form3);

//                 const billingInsurance = decryptedForm2?.BillingInsurance?.[0];
//                 const providerId = entry?.providerId?.[0];

//                 const isPayerMatch =
//                   billingInsurance?.payer?.value === payer?.id;
//                 const isProviderMatch =
//                   providerId === selectedProviders?.[0]?.id;
//                 const hasValidAuthDate =
//                   billingInsurance?.authorizationEndDate &&
//                   !moment
//                     .tz(billingInsurance.authorizationEndDate, userTimezone)
//                     .isBefore(moment.tz(new Date(), userTimezone), "day");

//                 if (isPayerMatch && isProviderMatch && hasValidAuthDate) {
//                   return {
//                     ...entry,
//                     name: decryptedname,
//                     form1: decryptedForm1,
//                     form2: decryptedForm2,
//                     form3: decryptedForm3,
//                   };
//                 }

//                 return null;
//               })
//               .filter(Boolean);
//           } else {
//             console.log("in the else");

//             matchingPatients = patients?.patients?.filter(
//               (patient) =>
//                 patient.form2?.BillingInsurance?.[0]?.payer.value ===
//                   payer?.id &&
//                 patient?.providerId?.[0].id === selectedProviders[0]?.id &&
//                 patient?.form2?.BillingInsurance?.[0]?.authorizationEndDate &&
//                 !moment
//                   .tz(
//                     patient.form2?.BillingInsurance?.[0]?.authorizationEndDate,
//                     userTimezone
//                   )
//                   .isBefore(moment.tz(new Date(), userTimezone), "day")
//             );
//           }

//           console.log("matchingPatients", matchingPatients);

//           if (matchingPatients?.length === 0) return;

//           matchingPatients?.forEach((selectedClient) => {
//             if (
//               !billingclient?.some(
//                 (client) =>
//                   client?.payer === payer.id &&
//                   client?.selectedClient.id === selectedClient.id &&
//                   selectedClient?.form2?.BillingInsurance?.[0]
//                     ?.authorizationEndDate &&
//                   !moment
//                     .tz(
//                       selectedClient.form2?.BillingInsurance?.[0]
//                         ?.authorizationEndDate,
//                       userTimezone
//                     )
//                     .isBefore(moment.tz(new Date(), userTimezone), "day")
//               )
//               .isBefore(moment.tz(new Date(), userTimezone), "day")
//         );

//         console.log("matchingPatients", matchingPatients);

//         if (matchingPatients?.length === 0) return;

//         matchingPatients?.forEach((selectedClient) => {
//           if (
//             !billingclient?.some(
//               (client) =>
//                 client?.payer === payer.id &&
//                 client?.selectedClient.id === selectedClient.id &&
//                 selectedClient?.form2?.BillingInsurance?.[0]
//                   ?.authorizationEndDate &&
//                 !moment
//                   .tz(
//                     selectedClient.form2?.BillingInsurance?.[0]
//                       ?.authorizationEndDate,
//                     userTimezone
//                   )
//                   .isBefore(moment.tz(new Date(), userTimezone), "day")
//             )
//           ) {
//             setBillingclient((prevState) => [
//               ...prevState,
//               {
//                 selectedClient,
//                 payer: payer.id,
//               },
//             ]);
//           }
//         });
//       });
//     }
//   }
//   }, [payerclient.length, selectedProviders.length,patients?.patients?.length]);

  // console.log("manage", manage);

  const SearchBillingProvider = async (providerSearch) => {
    let paylaod = {
      name: providerSearch,
      page: 1,
    };

    console.log("API Call: Search for ", providerSearch);

    try {
      await getBillingProvider(paylaod);
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  const SearchBillingPayer = async (payerSearch) => {
    let paylaod = {
      name: payerSearch,
      page: 1,
    };

    console.log("API Call: Search for ", payerSearch);

    try {
      await getpayer(paylaod);
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  // console.log("finalservices", finalservices);

  // console.log('billingdate',billingdate);

  // console.log("allbillingprovider", allbillingprovider);

  // console.log("allbillingclient", allbillingclient);

  const { allpayer } = useSelector((state) => state.payer);

  // console.log("makemanageall", makemanageall);
  // console.log("claimData", claimData);
  // console.log("profile", profile);

  // console.log('makemanageall',makemanageall);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // console.log('finalclaimdata',finalclaimdata);

  // console.log("billingdate", billingdate);

  const Viewservices = (services) => {
    // console.log("services", services);

    setExistingServices(services);

    setShowservices(true);
  };

  // console.log("billingnotes", billingnotes);

  function getDateRanges(start, end, billingschedule) {
    const ranges = [];
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let current = moment.tz(start, userTimezone).clone();
    const final = moment.tz(end, userTimezone).clone();

    if (billingschedule === "monthly") {
      while (current.isSameOrBefore(final, "month")) {
        const startOfMonth = current.clone().startOf("month");
        const endOfMonth = current.clone().endOf("month");
        ranges.push({
          label: `${startOfMonth.format("YYYY-MM-DD")} - ${endOfMonth.format(
            "YYYY-MM-DD"
          )}`,
          start: startOfMonth.clone().startOf("day"),
          end: endOfMonth.clone().endOf("day"),
        });
        current.add(1, "month");
      }
    } else if (billingschedule === "weekly") {
      current = current.startOf("day"); // Ensure correct time
      let isFirst = true;

      while (current.isSameOrBefore(final)) {
        let weekStart = isFirst
          ? current.clone()
          : current.clone().startOf("week");
        let weekEnd = isFirst
          ? current.clone().add(6 - current.day(), "days")
          : current.clone().endOf("week");

        if (weekEnd.isAfter(final)) weekEnd = final.clone();

        ranges.push({
          label: `${weekStart.format("YYYY-MM-DD")} - ${weekEnd.format(
            "YYYY-MM-DD"
          )}`,
          start: weekStart.clone().startOf("day"),
          end: weekEnd.clone().endOf("day"),
        });

        current = weekEnd.clone().add(1, "day").startOf("day");
        isFirst = false;
      }
    } else if (billingschedule === "exactdate") {
      const exactStart = moment.tz(start, userTimezone).startOf("day");
      const exactEnd = moment.tz(end, userTimezone).endOf("day");
      ranges.push({
        label: `${exactStart.format("YYYY-MM-DD")} - ${exactEnd.format(
          "YYYY-MM-DD"
        )}`,
        start: exactStart,
        end: exactEnd,
      });
    } else {
      // Default to daily
      while (current.isSameOrBefore(final, "day")) {
        const dayStart = current.clone().startOf("day");
        const dayEnd = current.clone().endOf("day");
        ranges.push({
          label: `${dayStart.format("YYYY-MM-DD")} - ${dayEnd.format(
            "YYYY-MM-DD"
          )}`,
          start: dayStart,
          end: dayEnd,
        });
        current.add(1, "day");
      }
    }

    return ranges;
  }

  useEffect(() => {
    if (
      billingclient?.length > 0 &&
      billingdate?.billingdata === "billingprogressnote" &&
      !editservices
    ) {
      const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const start = moment
        .tz(billingdate?.startdate, userTimezone)
        .startOf("day");
      const end = moment.tz(billingdate?.enddate, userTimezone).endOf("day");

      const dateRanges = getDateRanges(
        start,
        end,
        billingdate?.billingschedule
      );
      console.log("dateRanges", dateRanges);

      const finalServices = [];

      billingclient?.forEach((client) => {
        const services = client?.selectedClient?.form1?.services || [];

        services.forEach((service) => {
          dateRanges.forEach((range) => {
            const notesInRange = billingnotes?.data?.filter((note) => {
              const serviceType = note?.fields?.["Service Type"];
              const clientId = note?.fields?.["Client Name"];
              const noteDate = moment.tz(
                note?.fields?.["Service Date"],
                userTimezone
              );
              return (
                serviceType === service?.servicenumber &&
                clientId === client?.selectedClient?.id &&
                noteDate.isBetween(range.start, range.end, null, "[]")
              );
            });

            if (notesInRange.length === 0) return;

            const totalUnits = notesInRange
              .map((note) =>
                note?.fields?.["Unit/Day/Hours"]
                  ?.split(",")
                  .reduce((sum, val) => sum + parseFloat(val), 0)
              )
              .reduce((a, b) => a + b, 0);

            finalServices.push({
              ...service,
              patientId: client?.selectedClient?.id,
              serviceRate: totalUnits,
              totalCost: totalUnits * service?.servicechargeNumber,
              serviceDate: range.label,
              billingschedule: billingdate?.billingschedule || "daily",
            });
          });
        });
      });

      // SetFinalServcices((prev) => [...prev, ...finalServices]);
      SetFinalServcices(finalServices);
    }
  }, [billingclient, billingnotes]);

  // console.log("finalservices", finalservices);

  console.log("billingclient", billingclient);

  const addclientinbilling = async () => {
    try {
      if (manageall) {
        navigate("/home/billing");
      }

      if (!manageall && billingclient.length < 1) {
        await swal({
          title: "Please select All fields",
          text: "Please select client payer and provider",
          icon: "warning",
          dangerMode: true,
        });
        return;
      } else {
        const selectedClients = billingclient?.map(
          (client) => client?.selectedClient
        );
        // localStorage.setItem("selectedclient", JSON.stringify(selectedClients));

        await AddBillingCache({
          provider: selectedProviders,
          payer: payerclient,
          // client:selectedClients,
          client: selectedClients.map((client) => client.id),
          nextstep: "review",
        });

        // localStorage.removeItem("billingservices");
        // localStorage.removeItem("finalservices");

        setBillilingDateModal(true);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // console.log("##########patients", patients);

  // console.log('allbillingprovider?.billingprovider?.length',allbillingprovider?.billingprovider?.length);
  // console.log('selectedProviders',selectedProviders);

  const outcome = loading ? (
    <TableLoader />
  ) : (
    <ScrollArea
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      sx={{ minHeight: "300px" }}
    >
      <Paper
        sx={{
          borderRadius: "8px !important",
          border: "1px solid #E5E5E5 !important",
        }}
        withBorder
      >
        <Table
          highlightOnHover
          className={classes.tableRoot}
          enableStickyHeader={true}
          sx={{
            fontFamily: "Inter",
            "tbody tr:hover": {
              backgroundColor: "#FFF6ED !important",
            },
            // borderRadius: "5px",
            // border: "1px solid #E5E5E5",
          }}
          fontSize={"sm"}
          verticalSpacing={"md"}
        >
          <thead>
            <tr>
              <th></th>
              <th>
                <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                  {" "}
                  Provider Name{" "}
                </Text>
              </th>
              <th className={classes.header}>
                <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                  Provider Type{" "}
                </Text>{" "}
              </th>

              <th className={classes.header}>
                <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                  Enrollment Status{" "}
                </Text>{" "}
              </th>

              <th className={classes.header}>
                <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                  Billing Identifier{" "}
                </Text>
              </th>
              {/* <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Text Identifier{" "}
              </Text>
            </th> */}

              <th className={classes.header}>
                <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                  State
                </Text>
              </th>

              <th className={classes.header}>
                <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                  City
                </Text>
              </th>

              <th className={classes.header}>
                <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                  Zip Code
                </Text>
              </th>

              {/* {manageall ? (
              <th className={classes.header}>
                <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                  Add{" "}
                </Text>
              </th>
            ) : null} */}

              <th className={classes.header}>
                <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                  Actions{" "}
                </Text>
              </th>
            </tr>
          </thead>

          <tbody>
            {allbillingprovider?.billingprovider?.length > 0 ? (
              allbillingprovider?.billingprovider?.map((item, index) => {
                const isSelected = selectedProviders.some(
                  (provider) => provider.id === item.id
                );

                const handleRowClick = async () => {
                  if (isSelected) {
                    setSelectedProviders([]);
                  } else {
                    setSelectedProviders([item]);
                    // localStorage.setItem("laststep", "payer");
                    // localStorage.setItem(
                    //   "selectedprovider",
                    //   JSON.stringify([item])
                    // );
                    setState({ ...state, payer: true, provider: false });
                  }
                };

                const handleMenuClick = (event) => {
                  event.stopPropagation();
                };

                const bg = index % 2 === 0;
                const providerselected = selectedProviders.some(
                  (provider) => provider.id === item?.id
                );

                return (
                  <tr
                    key={item?.id}
                    // className={bg ? classes.bg2 : classes.bg1}
                    className={
                      providerselected
                        ? classes.selected
                        : bg
                        ? classes.bg2
                        : classes.bg1
                    }
                    // style={{
                    //   backgroundColor: selectedProviders.some(provider => provider.id === item?.id)
                    //     ? "#FFF6ED !important"
                    //     : isHovered
                    //     ? "#FFD580"
                    //     : "transparent",
                    // }}
                    onClick={!manageall ? handleRowClick : undefined}
                  >
                    <td>{index + 1}</td>
                    {/* <td className={classes.row}>
                      {item?.name}
                      {(!item?.name ||
                        !item?.address ||
                        !item?.phone ||
                        !item?.zipcode ||
                        !item?.federalTaxID ||
                        !item?.billingIdentifier ||
                        !item?.taxonomy ||
                        !item?.serviceCode ||
                        !item?.state ||
                        !item?.city ||
                        (!item?.services?.length && !manageall) ||
                        item?.providerEnrollment === false) && (
                        <Tooltip
                          label={
                            <>
                              {!item?.providerEnrollment && (
                                <>
                                  Provider is not enrolled in Claim MD
                                  <br />
                                </>
                              )}
                              {(!item?.name ||
                                !item?.address ||
                                !item?.phone ||
                                !item?.zipcode ||
                                !item?.federalTaxID ||
                                !item?.billingIdentifier ||
                                !item?.taxonomy ||
                                !item?.serviceCode ||
                                !item?.state ||
                                !item?.city ||
                                (!item?.services?.length && !manageall)) &&
                                "Provider Details Incomplete"}
                            </>
                          }
                          withArrow
                          position="bottom"
                        >
                          <img
                            width={20}
                            style={{ position: "relative", left: "20px" }}
                            src="/assets/images/error.png"
                            alt="check-icon"
                          />
                        </Tooltip>
                      )}
                    </td> */}
                    <td className={classes.row}>
                      {item?.name}
                      {(!item?.name ||
                        !item?.address ||
                        !item?.phone ||
                        !item?.zipcode ||
                        !item?.federalTaxID ||
                        !item?.billingIdentifier ||
                        !item?.taxonomy ||
                        !item?.serviceCode ||
                        !item?.state ||
                        !item?.city ||
                        (!item?.services?.length && !manageall) ||
                        item?.providerEnrollment === false) && (
                        <Tooltip
                          label={
                            <>
                              {!item?.providerEnrollment && (
                                <>
                                  Provider is not enrolled in Claim MD
                                  <br />
                                </>
                              )}
                              {(!item?.name ||
                                !item?.address ||
                                !item?.phone ||
                                !item?.zipcode ||
                                !item?.federalTaxID ||
                                !item?.billingIdentifier ||
                                !item?.taxonomy ||
                                !item?.serviceCode ||
                                !item?.state ||
                                !item?.city ||
                                (!item?.services?.length && !manageall)) &&
                                "Provider Details Incomplete"}
                            </>
                          }
                          withArrow
                          position="bottom"
                        >
                          <img
                            width={20}
                            style={{ position: "relative", left: "20px" }}
                            src="/assets/images/error.png"
                            alt="check-icon"
                          />
                        </Tooltip>
                      )}
                    </td>

                    <td className={classes.row}>{item?.providertype || "-"}</td>
                    <td className={classes.row}>
                      {item?.providerEnrollment === true ? "Yes" : "No"}
                    </td>

                    <td>
                      <Text
                        ff={"Inter"}
                        fz={"14px"}
                        fw={"600"}
                        color={"#262626"}
                      >
                        {item.billingIdentifier.number}
                      </Text>
                    </td>

                    <td className={classes.row}>{item?.state || "-"}</td>

                    <td className={classes.row}>{item?.city || "-"}</td>

                    <td className={classes.row}>{item?.zipcode || "-"}</td>

                    <td onClick={handleMenuClick}>
                      <Menu shadow="md" position="left" zIndex={1000}>
                        <Menu.Target>
                          <ActionIcon>
                            <BiDotsVerticalRounded size={20} color="#000" />
                          </ActionIcon>
                        </Menu.Target>
                        <Menu.Dropdown>
                          <Menu.Item
                            icon={<IconEye size={14} />}
                            onClick={() => handleEditProvider(item, true)}
                          >
                            View
                          </Menu.Item>
                          {manageall && (
                            <>
                              <Menu.Item
                                icon={<IconEdit size={14} />}
                                onClick={() => handleEditProvider(item, false)}
                              >
                                Edit
                              </Menu.Item>

                              {!item?.providerEnrollment && (
                                <Menu.Item
                                  icon={<IconClipboardCheck size={14} />}
                                  onClick={() =>
                                    handleProviderEnrollment(item, false)
                                  }
                                >
                                  Provider Enrollment
                                </Menu.Item>
                              )}

                              <Menu.Item
                                icon={<IconTrash size={14} />}
                                color="red"
                                onClick={() => handleRmoveProvider(item.id)}
                              >
                                Delete
                              </Menu.Item>
                            </>
                          )}
                        </Menu.Dropdown>
                      </Menu>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={1000}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      height: "55vh",
                      gap: "8rem",
                    }}
                  >
                    <RecordNotFound />
                    <Center>
                      <p className={classes.notFoundText}>
                        You don&apos;t have any record, Add Provider
                      </p>
                    </Center>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Paper>
      <Center>
        <CustomBillingPagination
          data={allbillingprovider?.count}
          itemsPerPage={10}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </Center>
    </ScrollArea>
  );

  // console.log('billingclient',billingclient);

  // console.log('payer client',payerclient);

  const handleClientSelection = async (value, payerid) => {
    // console.log("here");

    // console.log("patient value", value);

    // console.log("payerid", payerid);

    if (payerid === null) {
      await swal({
        title: "Please fill out the following fields",
        text: "please add payer",
        icon: "warning",
        dangerMode: true,
      });
      return;
    }

    const selectedClient = patients.patients.find(
      (patient) => patient.id === value.id
    );

    if (!selectedClient) return;

    if (
      !billingclient.some(
        (client) =>
          // client?.selectedClient?.id === selectedClient?.id &&
          client?.payer === payerid && client?.id === selectedClient?.id
      )
    ) {
      setBillingclient((prevState) => [
        ...prevState,
        {
          selectedClient,
          payer: payerid,
        },
      ]);
    }
  };

  console.log("selectedpayer", payerclient);

  const handlePayerSelection = async (payer) => {
    const isSelected = payerclient.some(
      (selectedPayer) => selectedPayer.id === payer.id
    );

    if (!isSelected) {
      // setPayerclient((prevState) =>
      //   prevState.filter((selectedPayer) => selectedPayer.id !== payer.id)
      // );
      setPayerclient([payer]);
      setState({ ...state, payer: false, provider: false, client: true });
    } else {
      // setPayerclient((prevState) => [...prevState, payer]);
      setPayerclient([]);
      setBillingclient([]);
    }
  };
  const handleEditPayer = (payer, view) => {
    // console.log("payer", payer);
    setView(view);
    setPayer(payer);
    setEditPayerModalOpen(true);
  };

  const handleremovePayer = async (id) => {
    let payload = {
      id,
    };

    console.log("payload", payload);

    // event.stopPropagation();
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removepayer(payload);
  };

  const handleRmoveProvider = async (id) => {
    let payload = {
      id,
    };

    console.log("payload", payload);

    // event.stopPropagation();
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removeProvider(payload);
  };

  const handleEditProvider = (item, view) => {
    setView(view);
    setProvideritem(item);
    setEditProvider(true);
  };


const handleProviderEnrollment=(item)=>{
setProviderEnrollment(true)
setProvideritem(item);

}

  const handleEditClient = (item, view) => {
    setView(view);
    setClient(item);
    setEditClient(true);
  };

  // const openModal = () => setEditModalOpen(true)

  const handlePayerRemove = (payerId) => {
    setPayerclient((prevState) =>
      prevState.filter((payer) => payer?.id !== payerId)
    );
  };

  const PayersInfoTable = ({ allpayer, loading }) => {
    return loading ? (
      <TableLoader />
    ) : (
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        sx={{ minHeight: "300px" }}
      >
        <Paper
          sx={{
            borderRadius: "8px !important",
            border: "1px solid #E5E5E5 !important",
          }}
          withBorder
        >
          <Table
            highlightOnHover
            className={classes.tableRoot}
            enableStickyHeader={true}
            sx={{
              fontFamily: "Inter",
              // borderRadius: "5px",
              // border: "1px solid #E5E5E5",
            }}
            fontSize={"sm"}
            verticalSpacing={"md"}
          >
            <thead>
              <tr>
                <th></th>
                <th className={classes.header} style={{ minWidth: "200px" }}>
                  Payer Name
                </th>
                <th className={classes.header} style={{ minWidth: "140px" }}>
                  Payer ID
                </th>
                <th className={classes.header} style={{ minWidth: "140px" }}>
                  State
                </th>
                <th className={classes.header} style={{ minWidth: "140px" }}>
                  Zip Code
                </th>
                {/* 
              {manageall ? (
                <th className={classes.header} style={{ minWidth: "140px" }}>
                  Add
                </th>
              ) : null} */}

                <th className={classes.header} style={{ minWidth: "140px" }}>
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={1000}>
                    <TableLoader />
                  </td>
                </tr>
              ) : allpayer?.payer?.length > 0 ? (
                allpayer?.payer?.map((payer, index) => {
                  const isSelected = payerclient.some(
                    (selectedPayer) => selectedPayer.id === payer.id
                  );

                  const handleMenuClick = (event) => {
                    event.stopPropagation();
                  };

                  const bg = index % 2 === 0;

                  return (
                    <tr
                      key={index}
                      // className={bg ? classes.bg2 : classes.bg1}
                      className={
                        isSelected
                          ? classes.selected
                          : bg
                          ? classes.bg2
                          : classes.bg1
                      }
                      // onClick={() => handlePayerSelection(payer)}
                      //  onClick={!manageall ? handlePayerSelection(payer) : undefined}
                      onClick={() => {
                        if (!manageall) {
                          handlePayerSelection(payer);
                        }
                      }}
                      style={{
                        backgroundColor: isSelected ? "#FFF6ED" : "transparent",
                      }}
                    >
                      <td>{index + 1}</td>
                      <td className={classes.row}>
                        {payer.payerName || "-"}

                        {(!payer?.payerName ||
                          !payer?.payerId ||
                          !payer?.payerAddress1 ||
                          !payer?.payerCity ||
                          !payer?.payerState ||
                          (!payer?.payerZip && !manageall)) && (
                          // <img
                          //   width={20}
                          //   style={{ position: "relative", left: "20px" }}
                          //   src="/assets/images/error.png"
                          //   alt="check-icon"
                          // />
                          <Tooltip
                            label="Payer Details Incomplete"
                            withArrow
                            position="bottom"
                          >
                            <img
                              width={20}
                              style={{ position: "relative", left: "20px" }}
                              src="/assets/images/error.png"
                              alt="check-icon"
                            />
                          </Tooltip>
                        )}
                      </td>
                      <td className={classes.row}>{payer.payerId || "-"}</td>
                      <td className={classes.row}>{payer.payerState || "-"}</td>
                      <td className={classes.row}>{payer.payerZip || "-"}</td>

                      <td onClick={handleMenuClick}>
                        <Menu shadow="md" position="left" zIndex={1000}>
                          <Menu.Target>
                            <ActionIcon>
                              <BiDotsVerticalRounded size={20} color="#000" />
                            </ActionIcon>
                          </Menu.Target>
                          <Menu.Dropdown>
                            <Menu.Item
                              icon={<IconEye size={14} />}
                              onClick={() => handleEditPayer(payer, true)}
                            >
                              View
                            </Menu.Item>

                            {manageall && (
                              <>
                                <Menu.Item
                                  icon={<IconEdit size={14} />}
                                  onClick={() => handleEditPayer(payer, false)}
                                >
                                  Edit
                                </Menu.Item>
                                <Menu.Item
                                  icon={<IconTrash size={14} />}
                                  color="red"
                                  onClick={() => handleremovePayer(payer.id)}
                                >
                                  Delete
                                </Menu.Item>
                              </>
                            )}
                          </Menu.Dropdown>
                        </Menu>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={1000}>
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "75vh",
                        gap: "1rem",
                      }}
                    >
                      <RecordNotFound />
                      <Center>
                        <p className={classes.notFoundText}>
                          You don&apos;t have any record, Add Payer
                        </p>
                      </Center>
                    </Box>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Paper>

        <Center>
          <CustomBillingPagination
            data={allpayer?.count}
            itemsPerPage={10}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Center>
      </ScrollArea>
    );
  };

  const PayersSearchTable = ({
    selectedPayer,
    searchloading,
    setSearchLoading,
  }) => {
    return searchloading ? (
      <TableLoader />
    ) : (
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        sx={{ minHeight: "300px" }}
      >
        <Table
          highlightOnHover
          className={classes.tableRoot}
          enableStickyHeader
          sx={{ fontFamily: "Inter", borderRadius: "15px" }}
          fontSize={"sm"}
          verticalSpacing={"md"}
        >
          <thead>
            <tr>
              <th className={classes.header} style={{ minWidth: "200px" }}>
                Payer Name
              </th>
              <th className={classes.header} style={{ minWidth: "140px" }}>
                Payer ID
              </th>
              <th className={classes.header} style={{ minWidth: "140px" }}>
                Payer State
              </th>
              <th className={classes.header} style={{ minWidth: "140px" }}>
                Payer type
              </th>

              <th className={classes.header} style={{ minWidth: "140px" }}>
                Payer Eligibility
              </th>

              <th className={classes.header} style={{ minWidth: "140px" }}>
                Payer Era
              </th>
              <th className={classes.header} style={{ minWidth: "140px" }}>
                Add
              </th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={1000}>
                  <TableLoader />
                </td>
              </tr>
            ) : selectedPayer ? ( // Check if selectedPayer exists
              <tr key={selectedPayer._id}>
                {" "}
                {/* Using selectedPayer._id as the key */}
                <td className={classes.row}>
                  {selectedPayer.payer_name || "-"}
                </td>
                <td className={classes.row}>{selectedPayer.payerid || "-"}</td>
                <td className={classes.row}>
                  {selectedPayer.payer_state || "-"}
                </td>
                <td className={classes.row}>
                  {selectedPayer.payer_type || "-"}
                </td>
                <td className={classes.row}>
                  {selectedPayer.eligibility || "-"}
                </td>
                <td className={classes.row}>{selectedPayer.era || "-"}</td>
                <td className={classes.row}>
                  <Button
                    className={classes.button}
                    onClick={() => handleAddPayer(selectedPayer)}
                    variant="fixed"
                    style={{
                      border: "1px solid var(--Gray-300, #D0D5DD)",
                      background: "#F9FAFB",
                      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                    }}
                    c={"#1D2939"}
                    bg={"#F9FAFB"}
                    // c={isSelected ? "#B42318" : "#000"}
                    // bg={isSelected ? "#FEF3F2" : "gray"}
                    radius={8}
                    size="md"
                  >
                    Add
                  </Button>
                </td>
              </tr>
            ) : (
              <tr>
                <td colSpan={1000}>
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "75vh",
                      gap: "1rem",
                    }}
                  >
                    <RecordNotFound />
                    <Text>You don&apos;t have any payer records.</Text>
                  </Box>
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* <CustomPagination
          data={allpayer?.count}
          itemsPerPage={8}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        /> */}
      </ScrollArea>
    );
  };

  const handleAddPayer = async (selectedPayer) => {
    try {
      let values = {
        payerName: selectedPayer.payer_name,
        payerId: selectedPayer.payerid,
        payerState: selectedPayer.payer_state
          ? selectedPayer.payer_state
          : "AZ",
        payerCity: "Phoenix",
        payerZip: "86052",
        payerAddress1: "1 2 3 street",
      };

      let payload = {
        values,
        admin: profile.user.id,
      };

      // console.log("add payload", payload);

      const res = await createpayer(payload);

      // console.log("res", res);

      // await updatestate(res);

      if (res.status === 200) {
        setSelectedPayer(null);
        let payload = { page: 1 };
        getpayer(payload);
        swal({
          title: `payer addded successfully`,
          text: "payer addded successfully",
          dangerMode: false,
        });
      }
    } catch (error) {
      console.log("erorr", error);
    }
  };

  // console.log("state", state);

  const PayerClientTable = ({
    patients,
    loading,
    // handleClientSelection,
    // handleClientRemove,
    // handleEditClient,
    // handlePayerRemove,
    // payerclient,
  }) => {
    // console.log("here");

    const hasPayerMatch = patients?.patients?.some((patient) => {
      const payerInfo = patient.form2?.BillingInsurance?.[0]?.payer ?? null;
      return (
        payerInfo && payerclient?.find((payer) => payer.id === payerInfo.value)
      );
    });

    // console.log('patients?.count',patients);

    return (
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        sx={{ minHeight: "300px" }}
      >
        <Paper
          sx={{
            borderRadius: "8px !important",
            border: "1px solid #E5E5E5 !important",
          }}
          withBorder
        >
          <Table
            highlightOnHover
            className={classes.tableRoot}
            enableStickyHeader={true}
            sx={{
              fontFamily: "Inter",
              // borderRadius: "15px !important",
              // border: "1px solid #E5E5E5",
            }}
            fontSize={"sm"}
            verticalSpacing={"md"}
          >
            <thead>
              <tr>
                {!manageall ? <th></th> : null}

                <th className={classes.header}>Client Name</th>
                <th className={classes.header}>State</th>
                <th className={classes.header}>City</th>
                <th className={classes.header}>Payer</th>
                <th className={classes.header}>Service</th>
                <th className={classes.header}>Gender</th>
                <th className={classes.header}>Authorization</th>
                <th className={classes.header}>Authorization EndDate</th>

                <th>ZipCode</th>

                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <TableLoader />
              ) : patients?.patients?.length > 0 ? (
                patients.patients.map((patient, index) => {
                  // console.log('patient',patient);

                  // selectedProviders[0]?.id

                  let isAuthorizationExpired = patient?.form2
                    ?.BillingInsurance?.[0]?.authorizationEndDate
                    ? moment
                        .tz(
                          patient.form2.BillingInsurance[0]
                            .authorizationEndDate,
                          userTimezone
                        )
                        .isBefore(moment.tz(new Date(), userTimezone), "day")
                    : false;

                  const payerInfo =
                    patient.form2?.BillingInsurance?.[0]?.payer ?? null;
                  const providerInfo = patient?.providerId?.[0]?.id ?? null;
                  const isPayerMatch =
                    payerInfo &&
                    providerInfo &&
                    !isAuthorizationExpired &&
                    payerclient?.some(
                      (payer) =>
                        payer.id === payerInfo.value &&
                        providerInfo === selectedProviders[0]?.id
                    );
                  if (!manageall && !isPayerMatch) return null;

                  const isSelected = billingclient?.some(
                    (selectedPayer) =>
                      selectedPayer.selectedClient.id === patient.id &&
                      !isAuthorizationExpired
                  );

                  const bg = index % 2 === 0;

                  // console.log("isSelected", isSelected);

                  return (
                    <tr
                      key={index}
                      // className={bg ? classes.bg2 : classes.bg1}
                      className={
                        isSelected
                          ? classes.selected
                          : bg
                          ? classes.bg2
                          : classes.bg1
                      }
                    >
                      {!manageall ? (
                        <td>
                          <Checkbox
                            checked={isSelected}
                            color="yellow"
                            disabled={
                              !patient?.form2?.BillingInsurance?.length ||
                              !patient?.form2?.BillingInsurance[0]?.payer
                                ?.value ||
                              (Array.isArray(payerclient) &&
                                !payerclient.some(
                                  (client) =>
                                    client.id ===
                                    patient.form2.BillingInsurance[0]?.payer
                                      ?.value
                                ))
                            }
                            onChange={() => {
                              if (isSelected) {
                                handleClientRemove(patient);
                              } else {
                                handleClientSelection(
                                  patient,
                                  payerInfo ? payerInfo.value : null
                                );
                              }
                            }}
                          />
                        </td>
                      ) : null}

                      <td>
                        {patient?.name || "-"}

                        {/* {!payerInfo?.value ||
                        !patient?.form2?.BillingInsurance ? (
                          <img
                            width={20}
                            style={{ position: "relative", left: "20px" }}
                            src="/assets/images/error.png"
                            alt="check-icon"
                          />
                        ) : null} */}

                        {!payerInfo?.value ||
                        isAuthorizationExpired ||
                        !patient?.form2?.BillingInsurance ? (
                          <Tooltip
                            // label="Client Details Incomplete"

                            label={
                              isAuthorizationExpired
                                ? "Authorization Date Expired"
                                : "Client Details Incomplete"
                            }
                            withArrow
                            position="bottom"
                          >
                            <img
                              width={20}
                              style={{ position: "relative", left: "20px" }}
                              src="/assets/images/error.png"
                              alt="check-icon"
                            />
                          </Tooltip>
                        ) : null}
                      </td>

                      <td>{patient.form1?.state || "-"}</td>
                      <td>{patient.form1?.city || "-"}</td>
                      <td>
                        {patient?.form2?.BillingInsurance?.[0]?.payer?.name ||
                          "-"}
                      </td>
                      <td>{patient?.form1?.services?.length || "-"}</td>
                      <td>{patient.form1?.gender || "-"}</td>
                      <td>
                        {patient?.form2?.BillingInsurance?.[0]?.authorization ||
                          "-"}
                      </td>
                      <td>
                        {patient?.form2?.BillingInsurance?.[0]
                          ?.authorizationEndDate
                          ? new Date(
                              patient?.form2?.BillingInsurance?.[0]?.authorizationEndDate
                            ).toLocaleDateString("en-US")
                          : "-"}
                      </td>

                      <td>{patient.form1?.zipCode || "-"}</td>
                      {/* <td>{"not filled"}</td> */}

                      {/* Menu options */}
                      <td>
                        <Menu shadow="md" position="left" zIndex={1000}>
                          <Menu.Target>
                            <ActionIcon>
                              <BiDotsVerticalRounded size={20} color="#000" />
                            </ActionIcon>
                          </Menu.Target>
                          <Menu.Dropdown>
                            <Menu.Item
                              icon={<IconEye size={14} />}
                              onClick={() => handleEditClient(patient, true)}
                            >
                              View
                            </Menu.Item>
                            {manageall && (
                              <>
                                <Menu.Item
                                  icon={<IconEdit size={14} />}
                                  onClick={() =>
                                    handleEditClient(patient, false)
                                  }
                                >
                                  Edit
                                </Menu.Item>
                                <Menu.Item
                                  icon={<IconTrash size={14} />}
                                  color="red"
                                  // onClick={() =>
                                  //   handlePayerRemove(patient.form2?.payer?.id)
                                  // }
                                >
                                  Delete
                                </Menu.Item>
                              </>
                            )}
                          </Menu.Dropdown>
                        </Menu>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={1000}>
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "75vh",
                        gap: "1rem",
                      }}
                    >
                      <RecordNotFound />
                      <Center>
                        <p className={classes.notFoundText}>
                          You don&apos;t have any record, Add Client
                        </p>
                      </Center>
                    </Box>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Paper>

        <Center>
          <CustomBillingPagination
            itemsPerPage={10}
            data={manageall ? patients?.count : 1}
            // data={patients?.count}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Center>
      </ScrollArea>
    );
  };

  //   const handleClientRemove = (billing_client) => {
  //     console.log(" in the billing_client", billing_client);

  //     const updatedBillingClient = billingclient.filter(
  //       (client) => console.log("client chekc", client),

  //      String(client?.selectedClient?.id) !== String(billing_client?.id)
  //       // ||
  //         // client?.payer !== billing_client?.payer
  //     );
  // console.log('updatedBillingClient',updatedBillingClient);

  //     setBillingclient(updatedBillingClient);
  //   };

  const handleClientRemove = (billing_client) => {
    console.log("In handleClientRemove, billing_client:", billing_client);

    if (!billing_client?.id) {
      console.error("No valid billing_client id found!");
      return;
    }

    const updatedBillingClient = billingclient.filter((client) => {
      console.log("Checking client:", client);

      return client?.selectedClient?.id !== billing_client?.id;
    });

    setBillingclient(updatedBillingClient);

    console.log("Updated billingclient:", updatedBillingClient);
  };

  function roundToTwoDecimals(value) {
    return Math.round(value * 100) / 100;
  }

  const handleStateChange = (stateToSet) => {
    setState({
      provider: stateToSet === "provider" ? true : false,
      client: stateToSet === "client" ? true : false,
      payer: stateToSet === "payer" ? true : false,
      reviewclaim: stateToSet === "reviewclaim" ? true : false,
      payment: stateToSet === "payment" ? true : false,
      addProvider: false,
      addClient: false,
      addPayer: false,
    });
    setCurrentPage(1);
    // setAgree(false)
  };

  // console.log("billingclient", billingclient);

  const SaveDraft = async () => {
    try {
      setDraftBillingLoading(true);

      await AddBillingCache({
        provider: selectedProviders,
        payer: payerclient,
        client: billingclient?.map((client) => client?.selectedClient?.id),
        billingServices: finalservices,
        billingServicesDates: billingdate,
        nextstep: "review",
      });

      navigate("/home/billing");

      setDraftBillingLoading(false);
    } catch (error) {
      setDraftBillingLoading(false);
      console.log("error", error);
    }
  };

  const SubmitClaims = (selectedProviders) => {
    // console.log("selectedProviders", selectedProviders);

    // setFinalClaimdata(selectedProviders)

    // console.log('test selectedProviders,',selectedProviders);
    // console.log('test selectedPayer',selectedPayer);
    // console.log('test billingclient',billingclient);

    const matchedClients = selectedProviders.billingclient.filter((client) =>
      selectedProviders.selectedPayer.some((payer) => payer.id === client.payer)
    );

    // setFinalClaimdata(selectedProviders)

    // console.log("matchedClients hahah", matchedClients);

    return (
      <>
        <Box className={classes.reviewpad}>
          {matchedClients.length > 0 ? (
            <>
              <Box className={classes.claimreviewbox}>
                {/* Displaying multiple payers */}
                {selectedProviders?.selectedPayer?.length > 0 &&
                  selectedProviders?.selectedPayer?.map((payer, index) => (
                    <Box key={index}>
                      <Text ff="Inter" fz={18} fw={400} color={"#737373"}>
                        Payer
                      </Text>
                      <Text ff="Inter" fz={24} fw={600} color={"#262626"}>
                        {payer.payerName}
                      </Text>
                    </Box>
                  ))}

                <Box>
                  <Text ff="Inter" fz={18} fw={400} color={"#737373"}>
                    Total Claim Amount
                  </Text>

                  <Text ff="Inter" fz={24} fw={600} color={"#262626"}>
                    $
                    {matchedClients
                      ?.reduce((total, client) => {
                        const clientTotal = finalservices?.reduce(
                          (sum, service) => sum + (service.totalCost || 0),
                          0
                        );
                        return clientTotal;
                      }, 0)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </Text>
                </Box>
              </Box>

              {billingdate?.billingdata === "manualbilling" &&
              matchedClients.some((client) =>
                finalservices.every(
                  (service) => service.patientId !== client.selectedClient.id
                )
              ) ? (
                <Box className={classes.alertbox}>
                  <img
                    width={60}
                    src="/assets/images/alertbillingBadge.png"
                    alt="back-icon"
                  />
                  <Text ff="Inter" fz={20} fw={500} color="#B42318">
                    Manual billing requires you to add the value of service
                    units
                  </Text>
                </Box>
              ) : billingdate?.billingdata === "billingprogressnote" ? (
                <Box className={classes.noticebox}>
                  <img
                    width={60}
                    src="/assets/images/notice badge.png"
                    alt="back-icon"
                  />
                  <Text ff="Inter" fz={20} fw={500} color="#B75A26">
                    Selecting Billing Progress Notes will automatically use
                    billing information from your previous notes
                  </Text>
                </Box>
              ) : null}

              <Table>
                <thead>
                  <tr>
                    <th className={classes.viewheaders}>Client Name</th>
                    <th className={classes.viewheaders}> Services</th>
                    <th className={classes.viewheaders}>Claim Amount</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {matchedClients.map((client, index) => (
                    <tr key={index}>
                      <td className={classes.viewpara}>
                        {client?.selectedClient?.name}
                      </td>
                      <td className={classes.viewpara}>
                        {client?.selectedClient?.form1?.services?.length}
                      </td>
                      <td className={classes.viewpara}>
                        ${" "}
                        {finalservices
                          .filter(
                            (service) =>
                              service.patientId === client.selectedClient.id
                          )
                          .reduce(
                            (sum, service) => sum + (service.totalCost || 0),
                            0
                          )
                          .toFixed(2)}
                      </td>

                      <td>
                        <Button
                          className={classes.button}
                          bg={"#D0D5DD"}
                          c={"#1D2939"}
                          fz={14}
                          fw={600}
                          onClick={() => Viewservices(client.selectedClient)}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          ) : (
            <Text>No matching clients found</Text>
          )}
        </Box>
      </>
    );
  };

  function formatDate(dateString) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  let settingtrue = settingdrawerOpened ? "#FFAF4A" : "#F0F0F0";

  const savebtn = async () => {
    try {
      if (finalservices.length < 1) {
        await swal({
          title: "Please fill out the Claim Amount For each Service",
          text: "Please fill out the Claim Amoun Services",
          icon: "warning",
          dangerMode: true,
        });

        return;
      }

      setBillingLoading(true);

      const billingdata = {
        filename: "",
        file: {},
        facilityId: null,
        patientId: null,
        admin: null,
        billingForm: null,
      };
      let jsondata = {
        fileid: "124",
        claim: [],
      };

      // let diagnosisFields = {};

      // console.log("selectedProviders", selectedProviders);
      // console.log("billingclient", billingclient);
      // console.log("payerclient", payerclient);

      billingclient?.forEach((billing_client) => {
        if (billing_client?.payer) {
          // const payer_patients_obj = billing_client.payer;

          const matchingPayer = payerclient.find(
            (payer) => payer.id === billing_client?.payer
          );

          if (matchingPayer) {
            console.log("Matched payer:", matchingPayer);
            console.log(" billing_client", billing_client);

            // Split the facility name for provider first and last name
            const nameParts = selectedProviders[0]?.name?.split(" ");
            console.log("nameParts", nameParts);

            const prov_name_f = nameParts[0] || "";
            const prov_name_l = nameParts[1] || "";

            // let charges = billing_client?.selectedClient?.form1?.services
            let charges = finalservices

              ?.filter(
                (service) =>
                  service.patientId === billing_client?.selectedClient.id &&
                  service.serviceRate !== 0
              )

              ?.map((service) => {
                console.log("tests service", service);

                return {
                  charge: service?.totalCost?.toFixed(2) || "",
                  charge_record_type: "UN",
                  diag_ref: "A",
                  from_date:
                    service?.serviceDate &&
                    (service.billingschedule === "monthly" ||
                      service.billingschedule === "weekly")
                      ? service?.serviceDate.split(" - ")[0]
                      : service?.serviceDate.split(" - ")[0],

                  // from_date: service?.serviceDate
                  //   ? service?.serviceDate
                  //   : billingdate?.startdate
                  //   ? billingdate.startdate.toISOString().split("T")[0]
                  //   : getCurrentDate(),

                  // from_date: service?.servicechargetype === "3month"
                  // ? billingdate?.startdate?.toISOString().split("T")[0]
                  // : service?.serviceDate
                  // ? service?.serviceDate
                  // : billingdate?.startdate
                  // ? billingdate.startdate.toISOString().split("T")[0]
                  // : getCurrentDate(),
                  place_of_service:
                    selectedProviders[0]?.serviceCode?.code || "",
                  proc_code: service?.servicenumber || "",
                  remote_chgid: "",
                  // thru_date: service?.serviceDate
                  // ? service?.serviceDate
                  // : billingdate?.enddate
                  // ? billingdate.enddate.toISOString().split("T")[0]
                  // : getCurrentDate(),
                  // thru_date:
                  //   service?.servicechargetype === "month"
                  //     ? billingdate?.enddate?.toISOString().split("T")[0]
                  //     : service?.serviceDate
                  //     ? service?.serviceDate
                  //     : billingdate?.enddate
                  //     ? billingdate.enddate.toISOString().split("T")[0]
                  //     : getCurrentDate(),

                  thru_date:
                    service?.serviceDate &&
                    (service.billingschedule === "monthly" ||
                      service.billingschedule === "weekly")
                      ? service?.serviceDate.split(" - ")[1]
                      : service?.serviceDate.split(" - ")[1],
                  units: service?.serviceRate || "1",
                };
              });

            // Prepare diagnosis fields for claim generation
            let diagnosisFields = {};
            let diagnosisArray =
              billing_client?.selectedClient?.form1?.diagnosis || [];

            // Loop through the diagnosis array and populate diagnosis fields
            if (Array.isArray(diagnosisArray) && diagnosisArray.length > 0) {
              diagnosisArray.forEach((item, index) => {
                const diagField = `diag_${index + 1}`;
                diagnosisFields[diagField] = item?.code || null;
              });
            }

            // Construct the claim object
            let claim_ = {
              accept_assign: "Y", // permanent field
              auto_accident: "N", // permanent field
              balance_due: "", // important

              // if selectedProviders[0]?.providertype === "individual"

              bill_addr_1: selectedProviders[0]?.address || "", // important
              bill_city: selectedProviders[0]?.city || "", // important
              bill_name: selectedProviders[0]?.name || "", // important
              bill_npi:
                selectedProviders[0]?.billingIdentifier?.type === "NPI"
                  ? selectedProviders[0]?.billingIdentifier?.number
                  : "", // important
              bill_phone: selectedProviders[0]?.phone || "",
              bill_state: selectedProviders[0]?.state || "",
              bill_taxid: selectedProviders[0]?.federalTaxID?.number || "", // important
              bill_id:
                selectedProviders[0]?.billingIdentifier?.type !== "NPI"
                  ? selectedProviders[0]?.billingIdentifier?.number
                  : "",
              bill_taxid_type:
                selectedProviders[0]?.federalTaxID?.type === "EIN" ? "E" : "S",
              bill_zip: selectedProviders[0]?.zipcode || "", // important

              // if selectedProviders[0]?.providertype === "Facility"

              // facility_name:
              //   selectedProviders[0]?.providertype === "facility"
              //     ? selectedProviders[0]?.name
              //     : "",
              // facility_addr_1:
              //   selectedProviders[0]?.providertype === "facility"
              //     ? selectedProviders[0]?.address
              //     : "",
              // facility_city:
              //   selectedProviders[0]?.providertype === "facility"
              //     ? selectedProviders[0]?.city
              //     : "",
              // facility_state:
              //   selectedProviders[0]?.providertype === "facility"
              //     ? selectedProviders[0]?.state
              //     : "",
              // facility_zip:
              //   selectedProviders[0]?.providertype === "facility"
              //     ? selectedProviders[0]?.zipcode
              //     : "",
              // facility_npi:
              //   selectedProviders[0]?.providertype === "facility" &&
              //   selectedProviders[0]?.billingIdentifier?.type === "NPI"
              //     ? selectedProviders[0]?.billingIdentifier?.number
              //     : "",
              // facility_id:
              //   selectedProviders[0]?.providertype === "facility" &&
              //   selectedProviders[0]?.billingIdentifier?.type !== "NPI"
              //     ? selectedProviders[0]?.billingIdentifier?.number
              //     : "",
              diagnosis: diagnosisArray,
              charge: charges,
              claim_form: claimData?.claimId || "837p",
              ...diagnosisFields,
              employment_related: "N",
              ins_addr_1:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.address1 || "", // important
              ins_city:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.city || "",
              ins_dob:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.dob || "",
              ins_group:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.groupPolicyNumber || "",
              ins_name_f:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.firstName || "",
              ins_name_l:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.lastName || "",
              ins_number:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.identificationNumber || "", // important
              ins_sex:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.gender === "Male"
                  ? "M"
                  : "F",
              ins_state:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.state || "",
              ins_zip:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.zipCode || "",
              pat_addr_1:
                billing_client?.selectedClient?.form1?.previousAddress || "", // important
              pat_city: billing_client?.selectedClient?.form1?.state || "", // important
              pat_dob: formatDate(billing_client?.selectedClient?.form1?.dob), // important
              pat_name_f:
                billing_client?.selectedClient?.form1?.firstName || "", // important
              pat_name_l: billing_client?.selectedClient?.form1?.lastName || "", // important
              pat_rel: "18", // Example, use actual data
              pat_sex:
                billing_client?.selectedClient?.form1?.gender === "Male"
                  ? "M"
                  : "F", // important
              pat_state: billing_client?.selectedClient?.form1?.state || "",
              pat_zip: billing_client?.selectedClient?.form1?.zipCode || "",
              payer_addr_1: matchingPayer.payerAddress1 || "",
              payer_city: matchingPayer.payerCity || "",
              payer_name: matchingPayer.payerName || "", // important
              payer_order: matchingPayer.payerOrder || "",
              payer_state: matchingPayer.payerState || "",
              payer_zip: matchingPayer.payerZip || "",
              payerid: matchingPayer.payerId || "", // important
              pcn:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.identificationNumber || "", // important
              prov_name_f: prov_name_f, // important
              prov_name_l: prov_name_l, // important
              prov_name_m: selectedProviders[0]?.facilityId?.name || "", // important
              // prov_npi: selectedProviders[0]?.billingIdentifier?.number || "",
              prov_npi:
                // selectedProviders[0]?.providertype === "individual" &&
                selectedProviders[0]?.billingIdentifier?.type === "NPI"
                  ? selectedProviders[0]?.billingIdentifier?.number
                  : "",
              prov_id:
                // selectedProviders[0]?.providertype === "individual" &&
                selectedProviders[0]?.billingIdentifier?.type !== "NPI"
                  ? selectedProviders[0]?.billingIdentifier?.number
                  : "",
              prov_taxonomy: selectedProviders[0]?.taxonomy || "",
              ref_name_f: "",
              ref_name_l: "",
              ref_name_m: "",
              ref_npi: "",
              remote_batchid: "",
              remote_claimid: "",
              remote_fileid: "",
              prior_auth:
                billing_client?.selectedClient?.form2?.BillingInsurance?.[0]
                  ?.authorization || "",
              total_charge: finalservices
                ?.filter(
                  (service) =>
                    service.patientId === billing_client?.selectedClient.id
                )
                ?.reduce((total, service) => {
                  const serviceTotal = service?.totalCost || 0;
                  return roundToTwoDecimals(total + serviceTotal);
                }, 0)
                .toFixed(2),
            };

            jsondata.claim.push(claim_);
          }
        }
      });

      billingdata.filename = selectedProviders[0]?.name || "new test";
      billingdata.file = encrypt(jsondata);
      billingdata.admin = profile?.user?.id;
      billingdata.billingForm = encrypt(jsondata);
      billingdata.draftId=billingItem?.id

      console.log("jsondata", jsondata);
      console.log("billingDsata", billingdata);
      const res = await createBilling(billingdata);

      if (res.status === 200) {
        swal({
          title: `Claim sent successfully`,
          text: "Claim sent  successful",
          icon: "success",
          dangerMode: false,
        });
      }
      setBillingLoading(false);
      //  navigate("/home/billing");
      // localStorage.removeItem("laststep");
      // localStorage.removeItem("selectedprovider");
      // localStorage.removeItem("selectedpayer");
      // localStorage.removeItem("selectedclient");
      // localStorage.removeItem("billingservices");
      // localStorage.removeItem("finalservices");

      navigate(
        `/home/billing?claimId=${claimData?.claimId || '837p'}&claimType=${claimData?.claimType || "professional"}`
      );

      await getAllBillingModal({ page: 1 });
    } catch (e) {
      console.log(e);

      navigate("/home/billing-claim-form");
    }
  };

  return (
    <>
      <Box fluid className="content">
        {/* <Topbar title={"Billing"} /> */}
        <AppNavbar title="Billing" profile={profile} />

        {(profile?.user?.billingAgree && state.provider === true) ||
        state.client === true ||
        state.reviewclaim === true ||
        state.payment === true ||
        state.payer === true ? (
          <div className={classes.mainbillingcontainer}>
            <Box
              // onClick={() => {
              //   navigate("/home/billing");
              // }}
              onClick={backfunction}
              className={classes.back}
            >
              <img
                width={20}
                src="/assets/images/chevron-backeleft.png"
                alt="back-icon"
              />
              <Text ff="Inter" fz={12} fw={400} color="#262626">
                Back
              </Text>
            </Box>

            {!manageall ? (
              <Box style={{ marginBottom: "9px" }}>
                <Text ff="Inter" fz={30} fw={600} color="#171717">
                  {(claimData?.claimType || "professional")
                    .charAt(0)
                    .toUpperCase() +
                    (claimData?.claimType || "professional").slice(1)}{" "}
                  Claim
                </Text>
              </Box>
            ) : null}

            <Box className={classes.selectbox}>
              <Box className={classes.insidebox}>
                {[
                  "provider",
                  "payer",
                  "client",
                  manage && "payment",
                  !manage && "reviewclaim",
                ]
                  .filter(Boolean)
                  .map((step) => {
                    const showCheck =
                      (step === "provider" && selectedProviders.length > 0) ||
                      (step === "payer" && payerclient.length > 0) ||
                      (step === "client" &&
                        billingclient.length > 0 &&
                        billingdate !== null);
                    // (step === "payment" && paymentype !== "") ||
                    // (step === "reviewclaim" && billingdate !== null);

                    // const formattedStep = step
                    // .replace(/([A-Z])/g, ' $1')
                    // .replace(/^./, (str) => str.toUpperCase())
                    // .trim();

                    //             const formattedStep = step
                    // .replace(/([a-z])([A-Z])/g, '$1 $2')
                    // .replace(/^./, (str) => str.toUpperCase())
                    // .trim(); //
                    return (
                      <Box
                        className={classes.iconbox}
                        key={step}
                        style={{ textAlign: "center" }}
                      >
                        <Text
                          ff="Inter"
                          fz={14}
                          fw={500}
                          onClick={() => {
                            if (
                              step === "payer" &&
                              !manageall &&
                              selectedProviders.length === 0
                            )
                              return;
                            if (
                              step === "client" &&
                              !manageall &&
                              payerclient.length === 0
                            )
                              return;
                            if (
                              step === "payment" &&
                              !manageall &&
                              paymentype === ""
                            )
                              return;
                            if (step === "reviewclaim" && billingdate === null)
                              return;
                            handleStateChange(step);
                          }}
                          color={!manage || state[step] ? "#000" : "#D4D4D4"}
                          className={`${classes.newbeginbilling} ${
                            state[step] ? classes.newborder : ""
                          }`}
                          style={{
                            cursor:
                              step === "payer"
                                ? selectedProviders.length > 0 || manageall
                                  ? "pointer"
                                  : "not-allowed"
                                : step === "client"
                                ? payerclient.length > 0 || manageall
                                  ? "pointer"
                                  : "not-allowed"
                                : step === "payment"
                                ? paymentype !== "" || manageall
                                  ? "pointer"
                                  : "not-allowed"
                                : step === "reviewclaim"
                                ? billingdate !== null
                                  ? "pointer"
                                  : "not-allowed"
                                : "pointer",
                          }}
                        >
                          {/* {step.charAt(0).toUpperCase() + step.slice(1)} */}
                          {step === "reviewclaim"
                            ? "Review Claim"
                            : step.charAt(0).toUpperCase() + step.slice(1)}

                          {/* {formattedStep} */}

                          {showCheck && (
                            <img
                              width={24}
                              height={24}
                              style={{ position: "relative", left: "8px" }}
                              src="/assets/images/Check icon.png"
                              alt="check-icon"
                            />
                          )}
                        </Text>
                      </Box>
                    );
                  })}
              </Box>
            </Box>

            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "26px",
                // marginBottom: "20px",
              }}
            >
              {!state.reviewclaim ? (
                <>
                  <Text ff="Inter" fz={16} fw={600} color="#171717">
                    {state.client ? "" : state.payer ? "" : ""}
                  </Text>
                  {/* <Text ff="Inter" fz={16} fw={600} color="#171717">
                    {state.client
                      ? "" || " "
                      : state.payer
                      ? selectedProviders[0]?.name || " "
                      : " "}
                  </Text> */}

                  {manageall && !state.payment ? (
                    <Button
                      onClick={() => {
                        const newState = {};
                        if (state.payer) {
                          newState.addPayer = true;
                        } else if (state.client) {
                          newState.addClient = true;
                        } else if (state.provider) {
                          newState.addProvider = true;
                        }
                        setState({ ...state, ...newState });
                      }}
                      variant="filled"
                      c="#000"
                      radius="md"
                      size="md"
                      color="yellow"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <img
                        style={{ width: "15px", marginRight: "10px" }}
                        src={"/assets/images/addiconBilling.png"}
                        alt="Add Icon"
                      />
                      {state.client
                        ? "Add Client"
                        : state.payer
                        ? "Add Payer"
                        : state.provider
                        ? "Add Provider"
                        : ""}
                    </Button>
                  ) : null}
                </>
              ) : (
                <>
                  <Box>
                    {/* <Text ff="Inter" fz={18} fw={400} color="#A1A1AA">
                      Claim ID:{" "}
                      <span style={{ color: "#171717" }}>
                        {claimData?.claimId}
                      </span>
                    </Text> */}

                    <Text
                      style={{ marginTop: "16px" }}
                      ff="Inter"
                      fz={20}
                      fw={400}
                      color="#A1A1AA"
                    >
                      Provider
                    </Text>
                    <Text ff="Inter" fz={30} fw={700} color="#262626">
                      {selectedProviders[0]?.name || "-"}
                    </Text>
                  </Box>

                  <Box>
                    <Text
                      ta="right"
                      ff="Inter"
                      fz={18}
                      fw={400}
                      color="#A1A1AA"
                    >
                      Billing Period
                    </Text>
                    <Text
                      ta="right"
                      ff="Inter"
                      fz={30}
                      fw={700}
                      color="#262626"
                    >
                      {/* {billingdate?.startdate && billingdate?.enddate
                        ? `${Math.floor(
                            (new Date(billingdate.enddate) -
                              new Date(billingdate.startdate)) /
                              (1000 * 60 * 60 * 24) 
                          )} Days`
                        : "Date not available"} */}
                      {billingdate?.startdate && billingdate?.enddate
                        ? `${
                            Math.floor(
                              (new Date(billingdate.enddate) -
                                new Date(billingdate.startdate)) /
                                (1000 * 60 * 60 * 24)
                            ) + 1
                          } Days` // Add 1 here
                        : "Date not available"}
                    </Text>

                    <Text ff="Inter" fz={20} fw={400} color="#A1A1AA">
                      Date :
                      <span style={{ color: "#171717", fontWeight: "600" }}>
                        {" "}
                        {new Date(billingdate?.startdate).toLocaleDateString(
                          "en-US",
                          { month: "short", day: "numeric", year: "numeric" }
                        )}{" "}
                        –{" "}
                        {new Date(billingdate?.enddate).toLocaleDateString(
                          "en-US",
                          { month: "short", day: "numeric", year: "numeric" }
                        )}
                      </span>
                    </Text>
                  </Box>
                </>
              )}
            </Box>

            {!state.reviewclaim && state.payer && manage ? (
              <>
                <Text
                  style={{ marginBottom: "16px" }}
                  c={"#171717"}
                  fz={16}
                  fw={600}
                >
                  Payer Information
                </Text>

                <Box className={classes.searchbox}>
                  {selectedPayer !== null ? (
                    <Box
                      onClick={clearsearch}
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        cursor: "pointer",
                        position: "relative",
                        top: "35px",
                        left: "1%",
                        // right:'1%'
                      }}
                    >
                      <ImCross size={12} />
                    </Box>
                  ) : null}

                  <BillingSearchBar
                    placeholder="Search payer name..."
                    data={
                      alllistpayer && alllistpayer.length > 0 && payerValue
                        ? alllistpayer.map((payer) => ({
                            value: payer,
                            label: payer?.payer_name,
                            key: payer?._id,
                          }))
                        : []
                    }
                    onChange={(value) => {
                      setSearchLoading(true);
                      setSelectedPayer(value);
                      if (typeof value === "string" && value) {
                        getpayerlist(value);
                      } else {
                        setSearchLoading(false);
                      }
                    }}
                    value={
                      typeof payerValue === "string"
                        ? payerValue
                        : payerValue?.payername
                    }
                    setValue={setPayerValue}
                    loading={searchloading}
                    // setLoading={setSearchLoading}
                  />
                </Box>
              </>
            ) : null}

            {!manage && !state.reviewclaim ? (
              <Box className={classes.suggestionbox}>
                <Text ff="Inter" fz={24} fw={600} color="#000">
                  {state.provider
                    ? "Choose a Provider for Your Claim"
                    : state.payer
                    ? "Choose a Payer for Your Claim"
                    : state.client
                    ? "Select Client(s)"
                    : null}
                </Text>

                <Box className={classes.suggestionminibox}>
                  <img
                    className={classes.img}
                    width={24}
                    height={24}
                    src="/assets/images/Featured icon.png"
                    alt="home"
                  />

                  <Text ff="Inter" fz={16} fw={600} color="#171717">
                    {state.provider
                      ? "Select a provider from the list below to begin the claim submission process."
                      : state.payer
                      ? "Select a payer from the list below to continue the claim submission process."
                      : state.client
                      ? "Please select the applicable client(s) to proceed with the claim submission."
                      : null}
                  </Text>
                </Box>
              </Box>
            ) : null}

            {!state.reviewclaim && state.provider ? (
              <Box style={{ marginTop: "20px" }} className={classes.searchbox}>
                <BillingSearchAll
                  placeholder="Search provider"
                  onChange={SearchBillingProvider}
                  value={providerSearch}
                  setValue={setProviderSearch}
                />
              </Box>
            ) : null}

            {!state.reviewclaim && state.payer && !manage ? (
              <Box style={{ marginTop: "20px" }} className={classes.searchbox}>
                <BillingSearchAll
                  placeholder="Search Payers"
                  onChange={SearchBillingPayer}
                  value={payerSearch}
                  setValue={setPayerSearch}
                />
              </Box>
            ) : null}

            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "25px",
                width: "97%",
              }}
            >
              {!state.reviewclaim ? (
                <>
                  {/* <Text ff="Inter" fz={16} fw={600} color="#171717">
                    {manageall
                      ? state.client
                        ? "Client List"
                        : state.payer
                        ? selectedPayer == null
                          ? "Added Payers"
                          : "Search Results"
                        : // ? "Payer List"
                        // ?"Added Payers"
                        state.provider
                        ? "Provider List"
                        : ""
                      : state.client 
                      ? "Select Client"
                      : state.payer
                      ? "Select Payer"
                      : state.provider
                      ? "Select Provider"
                      : " "}
                  </Text> */}

                  <Text ff="Inter" fz={16} fw={600} color="#171717">
                    {
                      manageall
                        ? state.client
                          ? "Client List"
                          : state.payer
                          ? selectedPayer == null
                            ? "Added Payers"
                            : "Search Results"
                          : state.provider
                          ? "Provider List"
                          : ""
                        : null
                      // state.client && manageall
                      // ? "Select Client"
                      // : state.payer
                      // ? "Select Payer"
                      // : state.provider
                      // ? "Select Provider"
                      // : ""
                    }

                    {state.client && !manageall && (
                      <Box>
                        <Text ff="Inter" fz={12} fw={400} color="#737373">
                          Provider Name
                        </Text>
                        <Text ff="Inter" fz={20} fw={500} color="#262626">
                          {selectedProviders[0]?.name || " "}
                        </Text>
                      </Box>
                    )}
                  </Text>

                  {state.client && !manageall ? (
                    <Box>
                      <Text ff="Inter" fz={12} fw={400} color="#737373">
                        Payer Name
                      </Text>

                      <Text ff="Inter" fz={20} fw={500} color="#262626">
                        {payerclient[0]?.payerName || " "}
                      </Text>
                    </Box>
                  ) : null}
                </>
              ) : (
                <></>
              )}
            </Box>

            <div className={classes.mainContainer}>
              <div className={classes.mainbillingbox}>
                <Box className={classes.container}>
                  <>
                    <Box className={classes.outcome}>
                      {state.payer ? (
                        <>
                          <Box
                            defaultValue="Outcome 1"
                            styles={{
                              chevron: {
                                marginLeft: 0,
                              },
                            }}
                          >
                            {state.client ? (
                              <PayerClientTable
                                patients={patients}
                                loading={loading}
                                PayerClientTable={PayerClientTable}
                              />
                            ) : state.provider ? (
                              outcome
                            ) : state.payer && selectedPayer == null ? (
                              <PayersInfoTable
                                allpayer={allpayer}
                                handlePayerRemove={handlePayerRemove}
                                handleClientSelection={handleClientSelection}
                                billingclient={billingclient}
                                patients={patients}
                                handleClientRemove={handleClientRemove}
                              />
                            ) : state.payer && selectedPayer !== null ? (
                              <PayersSearchTable
                                selectedPayer={selectedPayer}
                                searchloading={searchloading}
                                setSearchLoading={setSearchLoading}
                              />
                            ) : state.reviewclaim ? (
                              <SubmitClaims
                                selectedProviders={selectedProviders}
                                selectedPayer={payerclient}
                                billingclient={billingclient}
                              />
                            ) : state.payment ? (
                              <PaymentTab
                                paymentype={paymentype}
                                setPaymentType={setPaymentType}
                                setState={setState}
                                state={state}
                                manage={manage}
                                setAchServices={setAchServices}
                                achservices={achservices}
                              />
                            ) : (
                              <div>No valid state condition</div>
                            )}
                          </Box>
                        </>
                      ) : (
                        <></>
                      )}
                      <Accordion
                        defaultValue="Outcome 1"
                        styles={{
                          chevron: {
                            marginLeft: 0,
                          },
                        }}
                      >
                        {state.provider ? (
                          // Render provider-related outcome
                          outcome
                        ) : state.payer ? null : state.client ? ( // /> //   handleClientRemove={handleClientRemove} //   patients={patients} //   billingclient={billingclient} //   handleClientSelection={handleClientSelection} //   handlePayerRemove={handlePayerRemove} //   allpayer={allpayer} // Render PayersInfoTable when state.payer is true // <PayersInfoTable
                          // Render PayerClientTable when state.client is true
                          <PayerClientTable
                            allbillingclient={allbillingclient}
                            billingclient={billingclient}
                            patients={patients}
                            selectedProviders={selectedProviders}
                          />
                        ) : state.reviewclaim ? (
                          <SubmitClaims
                            selectedProviders={selectedProviders}
                            selectedPayer={payerclient}
                            billingclient={billingclient}
                          />
                        ) : state.payment ? (
                          <PaymentTab
                            paymentype={paymentype}
                            setPaymentType={setPaymentType}
                            setState={setState}
                            state={state}
                            manage={manage}
                            setAchServices={setAchServices}
                            achservices={achservices}
                          />
                        ) : null}
                      </Accordion>
                    </Box>
                  </>

                  {!state.reviewclaim && state.client ? (
                    <Box style={{ gap: "20px" }} className={classes.flexend}>
                      <Button
                        // onClick={addclientinbilling}
                        onClick={() => {
                          navigate("/home/billing");
                        }}
                        style={{ border: "1px solid #D0D5DD" }}
                        variant="default"
                        c="#000"
                        radius="md"
                        size="md"
                        bg="#F9FAFB"
                      >
                        Back
                      </Button>

                      <Button
                        onClick={addclientinbilling}
                        variant="filled"
                        // disabled={!billingclient.length > 0}
                        c="#000"
                        radius="md"
                        size="md"
                        color="yellow"
                      >
                        Save And Continue
                      </Button>
                    </Box>
                  ) : null}
                </Box>
              </div>
            </div>

            {state.reviewclaim ? (
              <>
                <Box
                  style={{
                    gap: "20px",
                    marginTop: "37px",
                    marginBottom: "102px",
                  }}
                  className={classes.flexend}
                >
                  <Button
                    onClick={SaveDraft}
                    loading={draftbillingloading}
                    // onClick={() => {
                    //   navigate("/home/dashboard");
                    // }}
                    variant="fixed"
                    c="#000"
                    radius="md"
                    size="md"
                    bg="#F9FAFB"
                  >
                    Save as Draft
                  </Button>

                  <Button
                    onClick={savebtn}
                    loading={billingloading}
                    variant="filled"
                    // disabled={!billingclient.length > 0}
                    c="#000"
                    radius="md"
                    size="md"
                    color="yellow"
                  >
                    Submit
                  </Button>
                </Box>
              </>
            ) : null}
          </div>
        ) : (
          <>
            <div className="mainbillingcontainer">
              <Box className={classes.tabs}>
                <Box className={classes.displaybox}>
                  <Box
                    style={{ cursor: "not-allowed" }}
                    className={classes.tabsinner}
                  >
                    <Text ff="Inter" fz={16} fw={600} color="#262626">
                      Start Professional Claim
                    </Text>
                  </Box>
                  <Box
                    style={{ cursor: "not-allowed" }}
                    className={classes.tabsinner}
                  >
                    <Text ff="Inter" fz={16} fw={600} color="#262626">
                      Start Institutional Claim
                    </Text>
                  </Box>
                  <Box
                    style={{ cursor: "not-allowed" }}
                    className={classes.tabsinner}
                  >
                    <Text ff="Inter" fz={16} fw={600} color="#262626">
                      Verify Service
                    </Text>
                  </Box>
                </Box>

                <Box
                  style={{ cursor: "pointer", backgroundColor: settingtrue }}
                  className={classes.tabsinner}
                >
                  <Box
                    // onClick={() => {
                    //   setSettingDrawerOpened(true);
                    // }}
                    style={{
                      display: "flex",
                      gap: "20px",
                      justifyContent: "center",
                      cursor: "not-allowed",
                    }}
                  >
                    <img
                      className={classes.img}
                      width={24}
                      height={24}
                      src="/assets/images/component.png"
                      alt="home"
                    />
                    <Text ff="Inter" fz={16} fw={600} color="#262626">
                      Setting
                    </Text>
                  </Box>
                </Box>
              </Box>

              {!profile?.user?.billingAgree ? (
                <>
                  <div className="maincontainer">
                    <div className="mainbillingbox">
                      <img src="/assets/images/billingimg.png" alt="Icon" />
                      <h1 className="terms">Terms and Agreement</h1>
                      <p className="termspara">
                        By signing up for Ogiso’s billing services you agree to
                        our billing terms and agreement. Ogiso charges a 2% to
                        3% fee of the total billing amount.
                      </p>
                      <Button
                        color="yellow"
                        className="signupbillingbtn"
                        padding={11}
                        onClick={() => {
                          setAgree(true);
                        }}
                      >
                        Signup
                      </Button>
                    </div>
                  </div>
                </>
              ) : allbillingprovider?.billingprovider?.length < 1 ? (
                <div className="maincontainer">
                  <div className="mainbillingbox">
                    <img src="/assets/images/billingimg.png" alt="Icon" />
                    <h1 className="terms">No Information</h1>
                    <p className="termspara">
                      You are currently missing important data to start billing.
                      Please add all missing information to begin billing.
                    </p>
                    <Button
                      color="yellow"
                      className="signupbillingbtn"
                      padding={11}
                      onClick={() => {
                        setState({ ...state, provider: true });
                      }}
                    >
                      Add Provider
                    </Button>
                  </div>
                </div>
              ) : null}
            </div>
          </>
        )}
      </Box>
      <AddPayer state={state} setState={setState} />
      <AddClient
        state={state}
        setState={setState}
        payerclient={payerclient}
        selectedProvider={selectedProviders[0]}
      />
      <AddProvider state={state} setState={setState} />
      <EditPayer
        EditPayerModalOpen={EditPayerModalOpen}
        setEditPayerModalOpen={setEditPayerModalOpen}
        item={payer}
        isPreview={view}
      />

      <ProviderEnrollment

      EditProviderEnrollmentModalOpen={providerEnrollment}
      setEditProviderEnrollmentrModalOpen={setProviderEnrollment}
      item={provideritem}
 
      
      />




      <EditProvider
        editprovider={editprovider}
        setEditProvider={setEditProvider}
        item={provideritem}
        isPreview={view}
      />

         <ProviderEnrollment

      EditProviderEnrollmentModalOpen={providerEnrollment}
      setEditProviderEnrollmentrModalOpen={setProviderEnrollment}
      item={provideritem}
 
      
      />



      <EditClient
        editclient={editclient}
        setEditclient={setEditClient}
        patient={client}
        isPreview={view}
        selectedProvider={selectedProviders[0]}
      />

      <AddBillingDate
        billingdatemodal={billingdatemodal}
        setBillilingDateModal={setBillilingDateModal}
        setBillilingDate={setBillilingDate}
        setState={setState}
        state={state}
        setExistingServices={setExistingServices}
      />

      <ViewClientClaimServices
        existingServices={existingServices}
        showservice={showservice}
        setShowservices={setShowservices}
        SetFinalServcices={SetFinalServcices}
        finalservices={finalservices}
        billingdate={billingdate}
        edit={editservices}
        setEdit={setEditServices}
        billingItem={billingItem}
      />

      <BillingAgree open={agree} setOpen={setAgree} />

      <Center>
        <SettingDrawer
          title="Settings"
          opened={settingdrawerOpened}
          close={closeSettingDrawer}
        />
      </Center>
    </>
  );
};

export default BillingClaimForm;
